module.exports = __webpack_public_path__ + "static/media/review-14.d1488c36.jpg";